module.exports = __webpack_public_path__ + "static/media/15.149f66bc.jpg";